






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Label } from '../components';

@Component({
  components: {
    Label,
  },
})
export default class Textarea extends Vue {
  @Prop({ type: String, default: '' })
  readonly label!: string;

  @Prop({ type: String, default: '' })
  readonly minHeight!: string;

  @Prop({ type: Number || undefined, default: undefined })
  readonly maxlength!: string;

  @Prop({ type: String, default: '' })
  readonly description!: string;

  @Prop({ type: String, default: '' })
  readonly value!: string;

  @Prop({ type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly readonly!: boolean;

  @Prop({ type: [Object, Function], default: null })
  readonly v!: any;

  @Prop({ type: Boolean, default: false })
  readonly bigLabel!: boolean;

  @Prop({ type: String, default: 'Ошибка!' })
  readonly errorText!: string;

  @Prop({ type: String, default: '' })
  readonly placeholder!: string;

  @Prop({ type: Boolean, default: false })
  readonly error!: boolean;

  @Prop({ type: String, default: 'auto' })
  readonly resize!: string;

  get vError(): boolean {
    return this.error || (this.v && this.v.$error);
  }

  text($event: any) {
    if (this.v) {
      this.v.$touch();
    }
    this.$emit('input', $event.target.value);
  }

  get getStyle() {
    return { '--text-area-resize': this.resize };
  }

  blur($event: any) {
    if (this.v) {
      this.v.$touch();
    }
    this.$emit('blur', $event);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/textarea/Textarea.vue